module.exports = __webpack_public_path__ + "img/PencilFull.64c24efa.png";